listCacheHas